export class Patient {
  id?: string;
  name: string;
  ssn: string;
  birthDate: Date;
  gender: string;
  civilStatus: string;
  address: string;
  state: string;
  city: string;
  phone: string;
  cellphone: string;
  email: string;

  constructor({
    id,
    name,
    ssn,
    birthDate,
    gender,
    civilStatus,
    address,
    state,
    city,
    phone,
    cellphone,
    email
  }: {
    id?: string;
    name: string;
    ssn: string;
    birthDate: Date;
    gender: string;
    civilStatus: string;
    address: string;
    state: string;
    city: string;
    phone: string;
    cellphone: string;
    email: string;
  }) {
    this.id = id;
    this.name = name;
    this.ssn = ssn;
    this.birthDate = birthDate;
    this.gender = gender;
    this.civilStatus = civilStatus;
    this.address = address;
    this.state = state;
    this.city = city;
    this.phone = phone;
    this.cellphone = cellphone;
    this.email = email;
  }
}
